/* eslint-disable eslint-comments/no-restricted-disable */
import type { PreloadFetchPolicy, EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/TeamActivitySpikeAppMemoQuery$parameters.ts';
import type { TeamActivitySpikeAppMemoQuery } from './__generated__/TeamActivitySpikeAppMemoQuery.graphql.ts';

// --- Spike constants (hardcoded; see QUERY.md) ---
const SPIKE_ACTORS = [
	'ari:cloud:identity::user/70121:5b131f21-3ccb-423c-81e5-18d3caae3479',
	'ari:cloud:identity::user/70121:133e1cc3-545c-4d55-9bd0-22a36d5fce4e',
	'ari:cloud:identity::user/63749bcff6c85b343c071f6c',
];
const SPIKE_N = 40;

type SpikeTeamActivityEntryPointComponent = EntryPointComponent<
	{
		teamActivityQuery: TeamActivitySpikeAppMemoQuery;
	},
	{},
	{},
	{}
>;

export const spikeTeamActivityEntryPoint: EntryPoint<
	SpikeTeamActivityEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<SpikeTeamActivityEntryPointComponent>(
		/* webpackChunkName: "async-spike-team-activity" */ './TeamActivitySpikeAppMemo.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (_params: EntryPointRouteParams) => {
		return {
			queries: {
				teamActivityQuery: {
					parameters,
					variables: {
						n: SPIKE_N,
						work: {
							type: 'AND' as const,
							actors: SPIKE_ACTORS,
							arguments: {
								eventTypes: [
									'created',
									'updated',
									'commented',
									'transitioned',
									'assigned',
									'published',
								],
							},
						},
						code: {
							type: 'AND' as const,
							actors: SPIKE_ACTORS,
							arguments: {
								products: ['bitbucket'],
								eventTypes: ['created', 'updated'],
							},
						},
					},
					options: {
						// oxlint-disable-next-line typescript/consistent-type-assertions
						fetchPolicy: 'network-only' as PreloadFetchPolicy,
					},
				},
			},
			entryPoints: {},
			extraProps: {},
		};
	},
});
